import { render, staticRenderFns } from "./InformarPago.vue?vue&type=template&id=13050bc4"
import script from "./InformarPago.vue?vue&type=script&lang=js"
export * from "./InformarPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports